import { partial, string } from 'io-ts/Decoder';

import { Request as PaginationRequest } from '../../generic/pagination/Request';
import { Request as FilterRequest } from '../../generic/search/filter/Request';
import { Request as GroupingRequest } from '../../generic/search/grouping/Request';
import { Request as ProjectionRequest } from '../../generic/search/projection/Request';
import { Request as SortRequest } from '../../generic/search/sort/Request';

export const Request = <
	SortField extends string,
	ColumnField extends string,
	StandardFilterField extends string,
	DateFilterField extends string,
	StageStatusFilterField extends string,
	BooleanFilterField extends string,
	GroupingField extends string = never,
>({
	sortFields,
	columnFields,
	standardFilterFields,
	dateFilterFields,
	stageStatusFilterFields,
	booleanFilterFields,
	groupingFields,
}: {
	sortFields: readonly SortField[];
	columnFields: readonly ColumnField[];
	groupingFields?: readonly GroupingField[];
	standardFilterFields: readonly StandardFilterField[];
	dateFilterFields: readonly DateFilterField[];
	stageStatusFilterFields: readonly StageStatusFilterField[];
	booleanFilterFields: readonly BooleanFilterField[];
}) =>
	partial({
		pagination: PaginationRequest,
		sort: SortRequest(sortFields),
		visibleColumns: ProjectionRequest(columnFields),
		hiddenColumns: ProjectionRequest(columnFields),
		searchTerm: string,
		filter: FilterRequest({
			standardFilterFields,
			dateFilterFields,
			stageStatusFilterFields,
			booleanFilterFields,
		}),
		grouping: GroupingRequest(groupingFields ?? []),
	});
